import { gql } from "apollo-boost";

export const SEND_FEEDBACK = gql`
  mutation SubmitFeedback($input: SubmitFeedbackByTopicInput!) {
    submitFeedbackByTopic(input: $input) {
      message
    }
  }
`;
